(() => {
  'use strict';

  function initialiseProduct(section) {
    if (section.dataset.productReady) return;
    const form = section.querySelector('[data-product-purchase-form]');
    const dataElement = section.querySelector('[data-product-data]');
    if (!form || !dataElement) return;
    let data;
    try { data = JSON.parse(dataElement.textContent); } catch (_) { return; }
    section.dataset.productReady = 'true';
    const product = data.product;
    product.variants.forEach((variant) => { variant.allocations = variant.allocations.filter((allocation) => allocation.recurring === true); });
    const variantInput = form.elements.namedItem('id');
    const quantityInput = form.elements.namedItem('quantity');
    const planInput = form.querySelector('[data-product-plan]');
    const planOptions = form.querySelector('[data-product-plan-options]');
    const planField = form.querySelector('[data-product-plan-field]');
    const purchaseRadios = [...form.querySelectorAll('[name="purchase_type"]')];
    const submit = form.querySelector('[data-product-submit]');
    const sticky = section.querySelector('[data-product-sticky-purchase]');
    const error = form.querySelector('[data-form-error]');
    const setError = (message = '') => {
      error.textContent = message;
      const stickyError = sticky?.querySelector('[data-sticky-error]');
      if (stickyError) { stickyError.textContent = message; stickyError.hidden = !message; }
    };
    const currency = new Intl.NumberFormat(data.locale || 'en-GB', { style: 'currency', currency: data.currency || 'GBP' });
    const money = (amount) => currency.format(amount / 100);
    const priceUnit = form.dataset.servingsPerBox === '12' ? 'per box' : 'each';
    const getVariant = () => product.variants.find((variant) => String(variant.id) === variantInput.value);
    const getQuantity = () => Math.max(1, Math.floor(Number(quantityInput?.value) || 1));
    const getAllocation = (variant) => variant?.allocations.find((plan) => String(plan.id) === planInput.value);
    const setText = (selector, text) => section.querySelectorAll(selector).forEach((element) => { element.textContent = text; });
    const isSubscription = () => purchaseRadios.some((radio) => radio.checked && radio.value === 'subscription');
    let previousVariant = null;
    let planChoices = [];
    let busy = false;
    let selectVariantMedia = () => {};

    function renderPlanChoices(allocations) {
      if (!planOptions || !planField) return;
      planOptions.querySelectorAll('.product-plan-choice').forEach((choice) => choice.remove());
      planChoices = allocations.map((allocation) => {
        const label = document.createElement('label');
        label.className = 'product-plan-choice';
        const radio = document.createElement('input');
        radio.type = 'radio';
        radio.name = 'delivery_plan_choice';
        radio.value = String(allocation.id);
        const name = document.createElement('span');
        name.className = 'product-plan-choice__name';
        name.textContent = allocation.name;
        const price = document.createElement('span');
        price.className = 'product-plan-choice__price';
        const amount = document.createElement('strong');
        const unit = document.createElement('small');
        unit.textContent = '/ order';
        price.append(amount, unit);
        label.append(radio, name, price);
        planOptions.append(label);
        return { radio, amount, allocation };
      });
      // Keep Shopify's named select as the single submitted selling-plan source.
      planField.hidden = true;
      planOptions.hidden = allocations.length === 0;
    }

    const addons = [...form.querySelectorAll('[data-product-addon]')].map((element) => {
      let addon;
      try { addon = JSON.parse(element.querySelector('[data-addon-data]').textContent); } catch (_) { return null; }
      addon.variants.forEach((variant) => { variant.allocations = variant.allocations.filter((allocation) => allocation.recurring === true); });
      return { element, product: addon, input: element.querySelector('[data-addon-variant]'), selected: element.querySelector('[data-addon-selected]') };
    }).filter(Boolean);

    function addonSelection(addon, selectedPlan) {
      const variant = addon.product.variants.find((item) => String(item.id) === addon.input.value);
      // A shared selling plan ID is the only guaranteed match. Never copy a plan
      // to a variant unless Shopify exposes that exact allocation for it.
      const allocation = selectedPlan && variant?.allocations.find((item) => item.id === selectedPlan.id);
      const allowed = variant?.available && (!addon.product.requiresPlan || allocation);
      return { variant, allocation, allowed };
    }

    const query = new URLSearchParams(window.location.search);
    const queryVariant = product.variants.find((variant) => String(variant.id) === query.get('variant'));
    if (queryVariant) variantInput.value = String(queryVariant.id);
    const queryQuantity = Number(query.get('quantity'));
    if (Number.isSafeInteger(queryQuantity) && queryQuantity > 0 && queryQuantity <= 99 && quantityInput) {
      if (quantityInput.tagName !== 'SELECT' || [...quantityInput.options].some((option) => Number(option.value) === queryQuantity)) quantityInput.value = String(queryQuantity);
    }
    const initialVariant = getVariant();
    const requestedPlan = initialVariant?.allocations.find((plan) => String(plan.id) === query.get('selling_plan'));
    const requestedPlanUnavailable = query.has('selling_plan') && !requestedPlan && query.get('purchase') !== 'one-time';
    const defaultSubscribe = form.dataset.defaultSubscribe === 'true' && query.get('purchase') !== 'one-time';
    if (product.requiresPlan || (query.get('purchase') !== 'one-time' && (requestedPlan || ((defaultSubscribe || query.get('purchase') === 'subscription') && initialVariant?.allocations.length)))) {
      purchaseRadios.forEach((radio) => { radio.checked = radio.value === 'subscription'; });
    }
    let subscriptionRequested = isSubscription() || query.get('purchase') === 'subscription' || (query.has('selling_plan') && query.get('purchase') !== 'one-time');

    function update() {
      const variant = getVariant();
      if (!variant) return;
      const hasPlans = variant.allocations.length > 0;
      if (previousVariant !== variant.id) {
        const oldPlan = previousVariant === null ? requestedPlan?.id : planInput.value;
        planInput.replaceChildren(...variant.allocations.map((allocation) => new Option(`${allocation.name} — ${money(allocation.price)} ${priceUnit}`, String(allocation.id))));
        if (variant.allocations.some((allocation) => String(allocation.id) === String(oldPlan))) planInput.value = String(oldPlan);
        if (previousVariant === null && requestedPlanUnavailable) planInput.selectedIndex = -1;
        renderPlanChoices(variant.allocations);
        purchaseRadios.forEach((radio) => { radio.checked = radio.value === (subscriptionRequested || product.requiresPlan ? 'subscription' : 'one-time'); });
        previousVariant = variant.id;
      }
      const needsPurchaseChoice = subscriptionRequested && !hasPlans && !product.requiresPlan;
      form.querySelector('[data-purchase-options]').hidden = !hasPlans && !needsPurchaseChoice;
      purchaseRadios.forEach((radio) => {
        radio.disabled = radio.value === 'subscription' ? !hasPlans : product.requiresPlan;
        if (!hasPlans && !product.requiresPlan) radio.checked = !needsPurchaseChoice && radio.value === 'one-time';
      });
      const subscribing = isSubscription() && hasPlans;
      planInput.disabled = !subscribing;
      form.querySelector('.product-subscribe-box').classList.toggle('is-selected', subscribing);
      form.querySelector('.product-subscribe-box').hidden = !subscribing;
      const allocation = subscribing ? getAllocation(variant) : null;
      const needsPlanChoice = subscribing && !allocation;
      const displayedPlan = getAllocation(variant);
      const quantity = getQuantity();
      planChoices.forEach(({ radio, amount, allocation: choice }) => {
        radio.checked = radio.value === planInput.value;
        radio.disabled = !subscribing;
        amount.textContent = money(choice.price * quantity);
      });
      const mainTotal = (allocation?.price ?? variant.price) * quantity;
      const unavailable = form.querySelector('[data-subscription-unavailable]');
      unavailable.hidden = (hasPlans && !needsPlanChoice) || (!subscriptionRequested && !product.requiresPlan);
      if (needsPlanChoice) unavailable.textContent = 'The linked delivery plan is no longer available. Choose an available delivery plan to continue.';
      else if (product.requiresPlan && !hasPlans) unavailable.textContent = 'This option needs a subscription plan, but no plan is currently available. Please choose another option.';
      else unavailable.textContent = 'Subscriptions are not currently available for this option. Choose another option or select One-time purchase to continue.';
      setText('[data-one-time-price]', money(variant.price * quantity));
      setText('[data-subscription-price]', displayedPlan ? money(displayedPlan.price * quantity) : '');
      setText('[data-product-price]', needsPlanChoice ? 'Choose a delivery plan' : money(mainTotal));
      const compareTotal = Number(variant.compareAtPrice) * quantity;
      const retailTotal = variant.price * quantity;
      if (compareTotal > retailTotal && !needsPlanChoice) {
        const reduction = Math.round((compareTotal - retailTotal) / compareTotal * 100);
        section.querySelectorAll('[data-product-price]').forEach((element) => {
          const was = document.createElement('s');
          was.textContent = money(compareTotal);
          was.setAttribute('aria-label', `Previous one-time price ${money(compareTotal)}`);
          if (!subscribing) element.append(' ', was);
          const note = document.createElement('div');
          note.className = 'product-price__reduction';
          note.style.fontSize = '0.8em';
          if (subscribing) {
            note.append('One-time price: ', was, ` now ${money(retailTotal)} · `);
          }
          note.append(`Save ${money(compareTotal - retailTotal)} (${reduction}%)${subscribing ? ' on one-time purchases' : ''}`);
          element.append(note);
        });
      }
      const saving = displayedPlan ? Math.max(0, Math.round((variant.price - displayedPlan.price) / variant.price * 100)) : 0;
      const savingElement = form.querySelector('[data-subscription-saving]');
      savingElement.hidden = !saving;
      savingElement.textContent = saving ? `Save ${saving}%` : '';
      const savingBenefit = form.querySelector('[data-subscription-saving-benefit]');
      if (savingBenefit) {
        savingBenefit.hidden = !saving;
        // Allocation prices describe this order; don't promise the same saving
        // on every renewal when a plan can have future price adjustments.
        savingBenefit.textContent = saving ? `Save ${saving}% on this order` : '';
      }
      const availability = form.querySelector('[data-plan-availability]');
      if (availability) {
        availability.hidden = !subscribing || variant.allocations.length !== 1;
        availability.textContent = 'This product currently has one delivery schedule available.';
      }
      setText('[data-subscription-price-line]', displayedPlan ? `${money(displayedPlan.price * quantity)} for this order on the selected plan` : 'Select a delivery plan');
      setText('[data-plan-description]', allocation?.description || '');
      setText('[data-plan-note]', subscribing && allocation ? allocation.name : 'Choose Subscribe to use a delivery plan.');
      let total = mainTotal;
      let addonCount = 0;
      let oneTimeAddons = 0;
      addons.forEach((addon) => {
        const selection = addonSelection(addon, allocation);
        const nextPlan = selection.allocation ? String(selection.allocation.id) : null;
        const billingChanged = addon.billingInitialised && addon.selected.checked && addon.previousPlan !== nextPlan;
        if (billingChanged) addon.selected.checked = false;
        addon.selected.disabled = !selection.allowed;
        if (!selection.allowed) addon.selected.checked = false;
        let summary = 'Unavailable';
        if (selection.allowed) {
          const price = selection.allocation?.price ?? selection.variant.price;
          summary = `${money(price)} · 1 item · ${selection.allocation ? `subscription: ${selection.allocation.name}` : 'one-time purchase'}`;
          if (addon.selected.checked) {
            total += price;
            addonCount += 1;
            if (!selection.allocation) oneTimeAddons += 1;
          }
        } else if (selection.variant?.available && addon.product.requiresPlan) summary = 'No matching subscription plan for this option';
        if (billingChanged) summary += ' · selection cleared; select again to confirm the updated purchase type and plan';
        addon.previousPlan = nextPlan;
        addon.billingInitialised = true;
        addon.element.querySelector('[data-addon-summary]').textContent = summary;
      });
      const countLabel = form.dataset.servingsPerBox === '12' ? `${quantity} ${quantity === 1 ? 'box' : 'boxes'}` : `${quantity} ${quantity === 1 ? 'item' : 'items'}`;
      const purchaseLabel = `${needsPurchaseChoice ? 'Choose purchase option' : subscribing ? 'Subscription' : 'One-time purchase'} · ${countLabel}`;
      setText('[data-product-total], [data-sticky-price]', needsPlanChoice ? '—' : money(total));
      setText('[data-sticky-label]', `${purchaseLabel}${addonCount ? ` + ${addonCount} extra${addonCount === 1 ? '' : 's'}` : ''}`);
      setText('[data-product-total-note]', `${needsPurchaseChoice ? 'Select a purchase option to continue' : subscribing ? allocation?.name || 'Choose a delivery plan' : 'One-time purchase'}${oneTimeAddons && subscribing ? ` · includes ${oneTimeAddons} one-time extra${oneTimeAddons === 1 ? '' : 's'}` : ''}`);
      const purchasable = variant.available && !needsPurchaseChoice && (!(product.requiresPlan || subscribing) || allocation);
      submit.disabled = busy || !purchasable;
      submit.textContent = !variant.available ? 'Sold out' : needsPurchaseChoice ? 'Choose purchase option' : needsPlanChoice ? 'Choose delivery plan' : !purchasable ? 'Plan unavailable' : busy ? 'Adding…' : subscribing ? 'Add subscription to basket' : 'Add to basket';
      const stickyButton = sticky?.querySelector('[data-sticky-submit]');
      if (stickyButton) { stickyButton.disabled = submit.disabled; stickyButton.textContent = !purchasable || busy ? submit.textContent : 'Add to basket'; }
    }

    form.addEventListener('change', (event) => {
      setError();
      if (event.target.name === 'purchase_type') subscriptionRequested = event.target.value === 'subscription';
      if (event.target.name === 'delivery_plan_choice') planInput.value = event.target.value;
      update();
      if (event.target === variantInput) {
        selectVariantMedia(getVariant()?.mediaId);
      }
    });
    quantityInput?.addEventListener('input', update);
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (busy || !form.reportValidity()) return;
      update();
      if (submit.disabled) return;
      const variant = getVariant();
      const allocation = isSubscription() ? getAllocation(variant) : null;
      if (isSubscription() && !allocation) { setError('Please choose an available delivery plan.'); return; }
      const item = { id: variant.id, quantity: getQuantity() };
      if (allocation) item.selling_plan = allocation.id;
      const items = [item];
      for (const addon of addons) {
        if (!addon.selected.checked) continue;
        const selection = addonSelection(addon, allocation);
        if (!selection.allowed) { setError('An extra flavour is no longer available. Please update your selection.'); return; }
        const extra = { id: selection.variant.id, quantity: 1 };
        if (selection.allocation) extra.selling_plan = selection.allocation.id;
        items.push(extra);
      }
      busy = true;
      setError();
      form.setAttribute('aria-busy', 'true');
      update();
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        const result = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'We could not add this order. Please check the selection and try again.');
        window.location.assign(`${root}cart`);
      } catch (failure) {
        setError(failure.message || 'We could not add this order. Please try again.');
        busy = false;
        form.removeAttribute('aria-busy');
        update();
      }
    });

    // Purchase readiness must not depend on optional gallery markup.
    update();
    const loading = form.querySelector('[data-purchase-loading]');
    if (loading) loading.hidden = true;
    if (sticky) {
      sticky.querySelector('[data-sticky-submit]').addEventListener('click', () => form.requestSubmit());
      const updateSticky = () => { const visible = form.getBoundingClientRect().bottom < 0; sticky.hidden = !visible; sticky.classList.toggle('is-visible', visible); };
      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky);
      updateSticky();
    }

    const gallery = section.querySelector('[data-product-gallery]');
    const controls = section.querySelector('[data-gallery-controls]');
    if (!gallery || !controls) return;
    const slides = [...gallery.querySelectorAll('.product-gallery__item')];
    if (!slides.length) return;
    const thumbs = [...section.querySelectorAll('[data-product-gallery-thumb]')];
    let activeSlide = 0;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function showSlide(index) {
      if (!slides.length) return;
      index = Math.max(0, Math.min(slides.length - 1, index));
      gallery.scrollTo({ left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: reducedMotion ? 'instant' : 'smooth' });
    }
    selectVariantMedia = (mediaId) => {
      const index = slides.findIndex((slide) => slide.id === `Media-${mediaId}`);
      if (index !== -1) showSlide(index);
    };
    function updateGallery() {
      const left = gallery.getBoundingClientRect().left;
      activeSlide = slides.reduce((closest, slide, index) => Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(slides[closest].getBoundingClientRect().left - left) ? index : closest, 0);
      thumbs.forEach((thumb) => { if (thumb.getAttribute('href') === `#${slides[activeSlide].id}`) thumb.setAttribute('aria-current', 'true'); else thumb.removeAttribute('aria-current'); });
      controls.querySelector('[data-gallery-previous]').disabled = activeSlide === 0;
      controls.querySelector('[data-gallery-next]').disabled = activeSlide === slides.length - 1;
      controls.querySelector('[data-gallery-status]').textContent = `${activeSlide + 1} / ${slides.length}`;
    }
    controls.hidden = slides.length < 2;
    controls.querySelector('[data-gallery-previous]').addEventListener('click', () => showSlide(activeSlide - 1));
    controls.querySelector('[data-gallery-next]').addEventListener('click', () => showSlide(activeSlide + 1));
    thumbs.forEach((thumb) => thumb.addEventListener('click', (event) => { event.preventDefault(); showSlide(slides.findIndex((slide) => `#${slide.id}` === thumb.getAttribute('href'))); }));
    gallery.addEventListener('keydown', (event) => { if (event.target !== gallery) return; if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); showSlide(activeSlide + (event.key === 'ArrowRight' ? 1 : -1)); } });
    let galleryFrame;
    gallery.addEventListener('scroll', () => { cancelAnimationFrame(galleryFrame); galleryFrame = requestAnimationFrame(updateGallery); }, { passive: true });
    updateGallery();
  }

  function initialiseAll(root = document) { root.querySelectorAll('[data-product-experience]').forEach(initialiseProduct); }
  initialiseAll();
  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
